<template>
  <div class="w-full h-screen overflow-hidden">
    <slot />
  </div>
</template>

<script setup lang="ts">
useHead({
  htmlAttrs: {
    class: 'viewer-locked',
  },
});
</script>
